import React, { createContext, useContext, useMemo, useState } from 'react';

const PrivacyMaskContext = createContext(null);

export const PrivacyMaskProvider = ({ children }) => {
  const [privacyMask, setPrivacyMask] = useState(() => localStorage.getItem('privacy_mask') === 'true');

  const togglePrivacyMask = () => {
    setPrivacyMask(prev => {
      const next = !prev;
      localStorage.setItem('privacy_mask', String(next));
      return next;
    });
  };

  const value = useMemo(() => ({ privacyMask, togglePrivacyMask }), [privacyMask]);
  return <PrivacyMaskContext.Provider value={value}>{children}</PrivacyMaskContext.Provider>;
};

export const usePrivacyMask = () => {
  const context = useContext(PrivacyMaskContext);
  if (!context) throw new Error('usePrivacyMask must be used within PrivacyMaskProvider');
  return context;
};

export default PrivacyMaskProvider;
